<div class="overlay" *ngIf="isOverlayVisible">
  <div class="overlay__content">
    <div
      class="overlay__wrapper"
      [class.overlay__wrapper--full-height]="config.isFullHeight"
      [class.overlay__wrapper--full-width]="config.isFullWidth"
      [style.height]="
        config.fixedContentHeight ? config.fixedContentHeight + 'px' : 'fit-content'
      "
    >
      <ng-content></ng-content>
    </div>
    <div
      class="overlay__shadow"
      (click)="config.doesClickingOutsideContentClose ? close() : null"
    ></div>
  </div>
  <qr-button
    *ngIf="config.isButtonCloseVisible"
    class="overlay__btn-close"
    [config]="buttonClose"
    (click)="close()"
  ></qr-button>
</div>
